import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Api from "@api";
import Menu from "@molecule/Menu";
import Loading from "@atom/Loading";
import ProgressiveImage from "@atom/ProgressiveImage";
import Admin from "./Admin";
import BlendGuide from "./Blendguide";
import Home from "./Home";
import PastPacks from "./PastPackss";
import data from "./data";
import style from "./style.scss";
import cn from "classnames";

const Screen = () => {
  const [finalLabels, setFinalLabels] = useState();

  useEffect(() => {
    Api.getFeatured().then((e) => {
      if (e.withblendguide && !finalLabels) {
        const newArray = data.navigation.menu;
        newArray.menuLabels.splice(1, 0, {
          label: "Blendguide",
          route: "/blendguide",
        });
        setFinalLabels(newArray);
      } else setFinalLabels(data.navigation.menu);
    });
  }, []);

  return (
    <div className={cn(style.container)}>
      <ProgressiveImage {...data.background} className={cn(style.bg)} />
      {finalLabels ? (
        <div className={cn(style.content)}>
          <Menu navi={finalLabels} socials={data.socials} />
          <Switch>
            <Route exact path={"/"} component={() => <Home />} />
            <Route
              path={"/blendguide"}
              component={() => <BlendGuide {...data.navigation} />}
            />
            <Route
              path={"/pastpacks"}
              component={() => <PastPacks {...data.navigation} />}
            />
            <Route
              path={"/binx-content-admin"}
              component={() => <Admin {...data.navigation} />}
            />
            <Redirect to={"/"} />
          </Switch>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Screen;
